import { Directive, ElementRef, AfterViewInit, inject } from '@angular/core';

@Directive({ selector: '[appAutoSelectAll]' })
export class AutoSelectAllDirective implements AfterViewInit {
  private element = inject(ElementRef);


  ngAfterViewInit() {
    this.element.nativeElement.focus();
    setTimeout(() => this.element.nativeElement.select());
  }
}
